export const Gender = {
  female: 'FEMALE',
  male: 'MALE',
  diverse: 'DIVERSE',
} as const;

export type GenderType = (typeof Gender)[keyof typeof Gender];